export default {
    institutionsTable: 'INSTITUTIONS',
    contactsTable: 'CONTACTS'
};

export const searchMinLength = 3;
